import React from "react";
import {Image} from 'react-bootstrap';
import Media from 'react-media';

import "./Partner.css";

import partner_ico from "../../asset/images/partner_ico.webp";
import partner_mobile_ico from "../../asset/images/partner_mobile_ico.webp";
import logo1 from "../../asset/images/logo1.webp";

// 合作伙伴
class Partner extends React.Component {
  render() {
    return (
      <div className="partner">
        <Image className="partner_ico" src={partner_ico} />
        <Media query="(min-width: 900px)" render={() =>
          (
            <Image className="partner_img" src={logo1} />
          )}
        />
        <Media query="(max-width: 900px)" render={() =>
          (
            <Image className="partner_mobile_img" src={partner_mobile_ico} />
          )}
        />
        
      </div>
    )
  }
}

export default Partner
